import React from 'react';
import { useParams } from 'react-router-dom';

import useSampleProjectData from '../../../hooks/useSampleProjectData';

import { Badge } from '../../general';

interface Props {
  heading: string;
  subheading?: string | React.ReactNode;
  icons?: React.ReactNode;
}

const PageHeader: React.FC<Props> = (props) => {
  const { eventId = '' } = useParams();

  const { heading, subheading, icons } = props;

  const { isSample } = useSampleProjectData(eventId);

  return (
    <div className="w-full min-h-10 flex flex-col justify-center gap-4">
      <div className="flex flex-wrap items-center justify-between gap-4">
        <div className="flex items-center gap-2 flex-wrap">
          <div className="font-bold uppercase text-xl sm:text-2xl leading-none">
            {heading}
          </div>

          {isSample && (
            <Badge
              text="Sample"
              variant="purple-gradient"
              tooltipText="This is a Sample Project, where you can try out CrowdClip® without providing any assets."
            />
          )}
        </div>

        {icons}
      </div>

      {subheading && <div>{subheading}</div>}
    </div>
  );
};

export default PageHeader;
